import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    script: Object
  }

  async start() {
    this.element.classList.add('d-none')

    for (let action of this.scriptValue.actions) {
      const widget = action.presentation_widget_identifier
        ? document.querySelector(`[data-identifier="${action.presentation_widget_identifier}"]`)
        : null;

      if (action.presentation_widget_identifier && !widget) {
        console.warn(`Widget with identifier "${action.presentation_widget_identifier}" not found`);
        continue;
      }

      switch (action.action) {
        case "scrollToWidget":
          this.scrollToWidget(widget);
          break;

        case "playVideo":
          this.playVideo(widget);
          break;

        case "waitForVideoToFinish":
          await this.waitForVideoToFinish(widget);
          break;

        case "sleep":
          await this.sleep(action.seconds);
          break;

        default:
          console.warn("Unknown action", action);
      }
    }

    if (this.scriptValue.loop) {
      this.start();
    }
  }

  scrollToWidget(widget) {
    const navbar = document.querySelector('.app-container > main > .header > .navbar');

    const offset = navbar ? navbar.offsetHeight : 0;
    const elementPosition = widget.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  playVideo(widget) {
    const bitmovinplayer = widget.querySelector('.bitmovinplayer-container');

    if (bitmovinplayer) {
      const player = window.players[bitmovinplayer.id];
      if (player) player.play();
    } else {
      const video_element = widget.querySelector('video');
      if (video_element) {
        if (!video_element.id) {
          video_element.id = `video-${Date.now()}`;
        }
        video_element.play();
        video_element.addEventListener("ended", () => {
          $(window).trigger("video-player:finished", [video_element.id]);
        }, { once: true });
      }
    }
  }

  waitForVideoToFinish(widget) {
    let videoId = null;

    const bitmovinplayer = widget.querySelector('.bitmovinplayer-container');
    if (bitmovinplayer) {
      videoId = bitmovinplayer.id;
    } else {
      const video_element = widget.querySelector('video');
      if (video_element) { videoId = video_element.id; }
    }

    if (!videoId) {
      console.warn(`No player or video found for widget`);
      return Promise.resolve();
    }

    return new Promise(resolve => {
      $(window).on("video-player:finished", function handler(e, id) {
        if (id === videoId) {
          $(window).off("video-player:finished", handler);
          resolve();
        }
      });
    });
  }

  sleep(seconds) {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
  }
}

